/**
 * Cloudflare Turnstile widget. Extracted from info_form.vue's waitForTurnstile() - previously
 * duplicated inline in the Vue mixin, this is now the shared helper for it.
 */
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tokenField', 'widget']
  static values = { siteKey: String }

  connect() {
    this.widgetId = null
    this.waitForTurnstile()
  }

  disconnect() {
    if (this.widgetId !== null) window.turnstile?.remove(this.widgetId)
  }

  waitForTurnstile(attempt = 0) {
    if (window.turnstile) {
      this.render()
      return
    }
    if (attempt > 50) return // ~10s of polling - give up quietly, matching a missing-script no-op

    setTimeout(() => this.waitForTurnstile(attempt + 1), 200)
  }

  render() {
    this.widgetId = window.turnstile.render(this.widgetTarget, {
      sitekey: this.siteKeyValue,
      theme: 'auto',
      callback: (token) => {
        this.tokenFieldTarget.value = token
      },
      'expired-callback': () => {
        this.tokenFieldTarget.value = ''
      },
      'error-callback': () => {
        this.tokenFieldTarget.value = ''
      }
    })
  }
}
